module.exports = __webpack_public_path__ + "img/elcomercio_original.03be5e91.png";